module.exports = __webpack_public_path__ + "img/AmericanExpress(BusinessChecking).1cd5752e.svg";